import { ModalResolveType, useModal } from '@src/lib/modal-manager'
import { Dialog, DialogButtonProps } from './Dialog'
import { uuid } from '@src/lib/uuid'
import { ReactNode } from 'react'

interface DialogOptionsBase {
  title?: string;
  message: string | ReactNode;
}

export interface DialogOptions extends DialogOptionsBase {
  buttons: DialogButtonProps[]
}

export interface AlertDialogOptions extends DialogOptionsBase {}

export interface ConfirmDialogOptions extends DialogOptionsBase {}

export function useDialog() {
  const { showModal } = useModal()
  const show = async (options: DialogOptions) => {
    const dialogId = uuid() as string
    const result = await showModal(Dialog, {
      id: dialogId,
      title: options.title,
      message: options.message,
      buttons: options.buttons
    })

    return result
  }

  const alert = async (options: AlertDialogOptions) => {
    const result = await show({
      ...options,
      buttons: [
        { variant: 'warning', text: '確定', resolveType: ModalResolveType.OK, value: true }
      ]
    })

    return result
  }

  const confirm = async (options: ConfirmDialogOptions) => {
    const result = await show({
      ...options,
      buttons: [
        { variant: 'secondary', text: '取消', resolveType: ModalResolveType.CANCEL, value: false },
        { variant: 'warning', text: '確定', resolveType: ModalResolveType.OK, value: true }
      ]
    })

    return result
  }

  return {
    dialog: {
      show,
      alert,
      confirm
    }
  }
}
